export default "__VITE_ASSET__BqRwneCl__"